import { useState, useEffect } from "react";
import { Button, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { deleteLocation } from "../../../store/actions/locationsAction";
import Popup from "../../common/modal/Popup";
import Loader from "../../common/loader/Loader";
const DeleteLocationPopup = ({
  deleteRec,
  onHide,
  deleteModalShow,
  setDeleteModalShow,
}) => {
  const {
    isRecordUpdated,
    error: apiError,
    isLoader,
  } = useSelector((state) => {
    return state.locations;
  });
  const [isAction, setIsAction] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const dispatch = useDispatch();

  const submitHandler = (mode) => {
    setIsAction(true);
    return dispatch(
      deleteLocation({
        locationId: deleteRec,
      })
    ).then((payload) => {
      console.log("payload", payload);
    });
  };
  useEffect(() => {
    if (isRecordUpdated) {
      setIsDone(true);
      onHide();
      setDeleteModalShow(false);
    }
  }, [isRecordUpdated]);

  return (
    <>
      <Popup
        onHide={() => onHide()}
        size="md"
        show={deleteModalShow}
        title={"Delete Geography"}
        footer={
          <>
            {apiError ? (
              <>
                <Button
                  variant="outline-dark model-btn me-4"
                  onClick={(e) => onHide()}
                >
                  Ok
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="outline-dark model-btn me-4"
                  onClick={(e) => onHide()}
                >
                  Cancel
                </Button>
                <Button
                  className="btn-primary model-btn"
                  onClick={(e) => submitHandler()}
                >
                  Confirm
                </Button>
              </>
            )}
          </>
        }
      >
        {isLoader && <Loader />}
        {apiError ? (
          <>
            {apiError && (
              <Alert variant={"danger"}>
                {apiError?.message || "Access denied! Please try again"}
              </Alert>
            )}
          </>
        ) : (
          <>
            <div style={{ textAlign: "center" }}>
              {"Are you sure you want to delete this geography?"}
            </div>
          </>
        )}
      </Popup>
    </>
  );
};

export default DeleteLocationPopup;
